import React from 'react';
import { FC } from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { create } from 'jss';
import rtl from 'jss-rtl';
import MomentUtils from '@date-io/moment';
import { SnackbarProvider } from 'notistack';
import { jssPreset, StylesProvider, ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import GlobalStyles from 'src/components/GlobalStyles';
import ScrollReset from 'src/components/ScrollReset';
import { AuthProvider } from 'src/contexts/Auth0Context';
import useSettings from 'src/hooks/useSettings';
import { createTheme } from 'src/theme';
import { prodRoutes, renderRoutes } from 'src/routes';
import { ApolloCustomProvider } from 'src/lib/apollo';
import { BrandProvider } from './contexts/BrandContext';
// import RegionDebugger from 'src/components/RegionDebugger'; // TODO: Remove in production

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const history = createBrowserHistory();

const App: FC = () => {
  const { settings } = useSettings();

  const theme = createTheme({
    direction: settings.direction,
    responsiveFontSizes: settings.responsiveFontSizes,
    theme: settings.theme
  });

  return (
    <ThemeProvider theme={theme}>
      <StylesProvider jss={jss}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <SnackbarProvider dense maxSnack={3}>
            <Router history={history}>
              <AuthProvider>
                <BrandProvider>
                  <ApolloCustomProvider>
                    <GlobalStyles />
                    <ScrollReset />
                    {renderRoutes(prodRoutes)}
                    {/* <RegionDebugger /> TODO: Remove in production */}
                  </ApolloCustomProvider>
                </BrandProvider>
              </AuthProvider>
            </Router>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </ThemeProvider>
  );
};

export default App;
